import React from 'react';

import './stylesheet.scss';
import { a18n } from '../../../../../utils/a18n';

const Baseline = () => <div className="artp-Header-Baseline artp-Header-item" dangerouslySetInnerHTML={{ __html: a18n('artprice.lib.heading.m1') }} />;

export default Baseline;
